module.exports = "/packs/013-0e018dccedf204f4c5584b0f32596b34.jpg";